<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import main from './App.js'
  export default main
</script>

<!-- Global style changes here -->
<style lang="scss">
  @import '../../assets/css/index.scss'
</style>

<!-- Local style changes here -->
<style lang="scss" scoped>
  @import './App.scss'
</style>



// WEBPACK FOOTER //
// App.vue?4c510286